<template lang="html">
  <div class="onboarding-guide">
    <Guide
      :content="content"
      :contentVideo="contentVideo"
      contentHeading="Website Appearance - Fonts"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'OnboardingColours',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'site',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'onboarding-colours',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'onboarding-launch',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p>Our team of UI designers have selected a range of Google Fonts which can be used on your website. You can change headings, sub-headings and body text.</p>

        <p>Font colours are changed based on the theme, as mentioned in the previous section. Font styling such as <strong>Bold</strong>, <em>italic</em> or <u>underlined</u> can be applied using the text editors.</p>

        <p>To change the font on your website, go to the <strong>Appearance panel</strong>.</p>
        `
    },

    contentVideo() {
      return 'https://cdn.shopify.com/assets2/home/manage-animation-a9cecf49c4414fd02d9fa00482fd30e436fc373208255d90d92491be650b8d13.mp4'
    }
  }
}
</script>
